import { VenueUpdateSubscriptionInput } from '../../graphql/API';
import { venueUpdateSubscription } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueUpdateSubscriptionApi = async (
  input: VenueUpdateSubscriptionInput,
): Promise<void> => {
  await executeGql<void>(venueUpdateSubscription, { input });
};
